module.exports = __webpack_public_path__ + "static/close-701eea0b3c0feb606d746e7fd681e8a3.png";